var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHands(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 690,
    height: 560,
    viewBox: "0 0 690 560",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_15607)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6_15607",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 690,
    height: 560
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M690 0H0V560H690V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6_15607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.782 477.099L602.916 278.203C603.542 277.417 604.161 276.621 604.772 275.817C605.383 275.013 605.984 274.206 606.574 273.392L607.428 272.268L607.397 272.244C649.27 213.271 637.044 131.282 579.031 87.2017C521.017 43.1211 438.748 53.3084 393.149 109.451L393.066 109.387L237.421 314.22L451.782 477.099Z",
    fill: "#F15225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.136 307.387L434.326 308.577C486.53 360.779 486.53 445.547 434.326 497.749C382.122 549.951 297.351 549.951 245.147 497.749L243.957 496.559C191.752 444.357 191.752 359.589 243.957 307.387C296.161 255.185 380.932 255.185 433.136 307.387Z",
    fill: "#F5ED63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.966 91.5077C41.3858 136.405 30.2776 220.418 75.1766 278.996L232.132 483.769C277.031 542.347 361.048 553.455 419.628 508.558C478.209 463.661 489.317 379.647 444.418 321.069L287.462 116.296C242.563 57.7182 158.546 46.6106 99.966 91.5077Z",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.323 357.829L285.461 463.164C294.445 474.827 292.27 491.592 280.605 500.576C268.941 509.56 252.176 507.384 243.191 495.721L162.053 390.386C153.069 378.722 155.245 361.957 166.909 352.973C178.573 343.989 195.338 346.165 204.323 357.829Z",
    stroke: "black",
    strokeWidth: 1.90001
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.958 375.366L366.096 480.701C375.081 492.365 372.905 509.129 361.241 518.113C349.576 527.097 332.811 524.922 323.827 513.258L242.689 407.923C233.704 396.259 235.88 379.495 247.544 370.511C259.209 361.527 275.974 363.702 284.958 375.366Z",
    stroke: "black",
    strokeWidth: 1.90001
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.083 341.88L417.092 460.029C426.077 471.693 423.901 488.458 412.237 497.442C400.572 506.426 383.807 504.25 374.823 492.586L283.814 374.437C274.829 362.773 277.005 346.009 288.669 337.025C300.334 328.041 317.099 330.216 326.083 341.88Z",
    stroke: "black",
    strokeWidth: 1.90001
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.16 310.832L450.298 416.167C459.283 427.831 457.107 444.595 445.442 453.579C433.778 462.563 417.013 460.388 408.028 448.724L326.89 343.389C317.906 331.725 320.082 314.961 331.746 305.977C343.41 296.993 360.175 299.168 369.16 310.832Z",
    stroke: "black",
    strokeWidth: 1.90001
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.654 221.208L435.542 309.341C444.527 321.005 442.351 337.769 430.687 346.753C419.022 355.737 402.257 353.562 393.273 341.898L325.385 253.765C316.4 242.101 318.576 225.337 330.24 216.352C341.905 207.368 358.67 209.544 367.654 221.208Z",
    stroke: "black",
    strokeWidth: 1.90001
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_15607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 690,
    height: 560,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHands);
export default __webpack_public_path__ + "static/media/hands.325f118b3ad3c7cfe5f9546e20a9b791.svg";
export { ForwardRef as ReactComponent };